import { useState } from "react";

const useHandleRightPane = ({
  fieldId = "",
  currentRightPane = "",
  showRightPane = false,
  rightPaneAnimationTime = 300,
  shouldCloseCurrentPane = true,
  fieldUid = "",
  shouldFocusHelpIconOnClose = false,
}) => {
  const [state, setState] = useState({
    fieldId,
    currentRightPane,
    showRightPane,
    fieldUid,
  });

  const updateState = params => {
    setState(prevState => {
      return { ...prevState, ...params };
    });
  };

  const handleRightPane = ({ rightPane, id = "", uid }) => {
    const { currentRightPane, fieldId } = state;
    if (fieldId == id && rightPane == currentRightPane) {
      setTimeout(() => {
        updateState({
          currentRightPane: "",
          fieldId: "",
          showRightPane: false,
          fieldUid: "",
        });
      }, rightPaneAnimationTime);
      return;
    }
    if (currentRightPane) {
      if (shouldCloseCurrentPane) {
        updateState({
          showRightPane: false,
        });
      }
      setTimeout(() => {
        updateState({
          currentRightPane: rightPane,
          fieldId: id,
          showRightPane: rightPane ? true : false,
          fieldUid: uid,
        });
      }, rightPaneAnimationTime + 30);
    } else {
      if (!rightPane) {
        setTimeout(() => {
          updateState({
            currentRightPane: "",
            fieldId: "",
            showRightPane: false,
            fieldUid: "",
          });
        }, rightPaneAnimationTime);
      } else {
        updateState({
          currentRightPane: rightPane,
          fieldId: id,
          showRightPane: true,
          fieldUid: uid,
        });
      }
    }
  };

  const onCloseRightPane = () => {
    if (shouldFocusHelpIconOnClose && state.currentRightPane == "help") {
      const buttonElement = document.getElementById(
        `help-button-${state.fieldUid}`
      );
      if (buttonElement) {
        buttonElement.focus();
      }
    }
    handleRightPane({ rightPane: "" });
  };

  return {
    onCloseRightPane,
    handleRightPane,
    updateState,
    currentRightPane: state.currentRightPane,
    fieldId: state.fieldId,
    showRightPane: state.showRightPane,
    fieldUid: state.fieldUid,
  };
};

export default useHandleRightPane;
